// Resolve a URL de exibicao do banner.
//
// O backend grava o caminho SEM o prefixo do router (`/uploads/banners/x.webp`),
// mas quem serve o arquivo e' `GET /api/uploads/banners/{filename}`. Usar o valor
// cru no `src` da <img> da 404 — foi exatamente o que aconteceu no primeiro
// banner cadastrado. Mesma convencao das fotos de produto (`getImageUrl` no
// cardapio), aqui isolada num ponto so pra nao divergir entre painel e cardapio.

export function bannerImageUrl(url) {
  if (!url) return "";
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  if (url.startsWith("/uploads/")) return `/api${url}`;
  return url;
}
